import { render, staticRenderFns } from "./kdApprovalFlow.vue?vue&type=template&id=517a75a3&scoped=true"
import script from "./kdApprovalFlow.vue?vue&type=script&lang=js"
export * from "./kdApprovalFlow.vue?vue&type=script&lang=js"
import style0 from "./kdApprovalFlow.vue?vue&type=style&index=0&id=517a75a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a75a3",
  null
  
)

export default component.exports